// Guarda o href "base" de cada favicon (o que a layout ERB definiu — pode ser o
// custom do branding/LOGO_THUMBNAIL ou o padrão do Chatwoot) para restaurar ELE,
// em vez de forçar sempre o /favicon-*.png padrão (que apagava a logo custom da aba).
const captureBase = favicon => {
  if (!favicon.dataset.baseHref) {
    favicon.dataset.baseHref = favicon.getAttribute('href') || '';
  }
  return favicon.dataset.baseHref;
};

// Custom = href que NÃO é um /favicon-<size>.png padrão (ex.: URL do ActiveStorage).
const isCustomFavicon = href =>
  !!href && !/\/favicon-[\dx]+\.png(\?.*)?$/.test(href);

export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    const base = captureBase(favicon);
    // Com favicon custom (branding), mantém o custom — não troca pro badge padrão do
    // Chatwoot (senão a aba "voltaria" pro ícone original a cada notificação).
    favicon.href = isCustomFavicon(base)
      ? base
      : `/favicon-badge-${favicon.sizes[0]}.png`;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');
  favicons.forEach(captureBase);

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        // restaura o href base (custom quando houver branding); fallback ao padrão
        favicon.href =
          captureBase(favicon) || `/favicon-${favicon.sizes[0]}.png`;
      });
    }
  });
};
